// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PHONE = "Telefon";
export const SIGNUP_AVATAR = "Profilov\u00e1 fotka";
export const SIGNUP_TITLE = "Registrace";
